<template>
  <v-autocomplete
    outlined
    hide-details
    return-object
    no-filter
    hide-selected
    hide-no-data
    chips
    deletable-chips
    multiple
    small-chips
    :clearable="clearable"
    :item-text="itemText"
    item-value="id"
    :label="label"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    v-model="localValue"
    @blur="onBlur"
    @change="onChange"
    @focus="onFocus"
    v-bind="$attrs"
  >
    <template v-slot:item="item">
      <slot name="item" v-bind:item="item">
        <template v-if="!showDetails">
          <span>{{item.item[itemText]}}</span>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title>
              <px-chip-codigo-interno :codigo-interno="item.item.codigo"/>
              {{ item.item.descricao }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ item.item.especificacao | truncate(75) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </slot>
    </template>
    <template v-slot:selection="item">
      <div class="truncate-text">
        <px-chip-codigo-interno :codigo-interno="item.item.codigo"/>
        {{ item.item.descricao }}
        <v-btn small icon @click="onRemoveItem(item.index)">
          <v-icon small class="mb-1">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import ProdutosService from '@/api/produtos-service';

const DEFAULT_LIMIT = 100;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: [Object, Array],
    label: {
      type: String,
      default: 'Produto',
    },
    onlyCotavel: {
      type: Boolean,
      default: true,
    },
    onlyPadrao: {
      type: Boolean,
      default: false,
    },
    customFilter: {
      type: String,
      default: null,
    },
    showDetails: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    itemText: {
      type: String,
      default: 'descricao',
    },
    defaultEmptyCode: {
      type: String,
      default: 'Padrão',
    },
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      if (!val || (this.localValue && this.localValue.descricao === val)) return;
      this.debounceSearch(val);
    },
  },
  methods: {
    buildFilter(filter) {
      let query = `(descricao like "%${filter}%" or codigo like "${filter}%") and ativo is true`;
      if (this.onlyCotavel) {
        query = `${query} and isCotavel = true`;
      }

      if (this.onlyPadrao) {
        query = `${query} and entidade is null`;
      }

      if (this.customFilter) {
        query = `${query} and ${this.customFilter}`;
      }
      return `${query} order by codigo`;
    },
    searchProdutos(val) {
      const filter = val ? val.toLowerCase().replaceAll(' ', '%') : '';

      this.loading = true;
      const query = this.buildFilter(filter);

      ProdutosService.getProdutosPage({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query,
      })
        .then((response) => {
          this.items = response.data.content;
          if (this.value && this.value.length) {
            this.items = [...this.items, ...this.value];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange(event) {
      this.$emit('change', event);
    },
    onFocus() {
    },
    onRemoveItem(index) {
      this.localValue.splice(index, 1);
      this.$emit('input', this.localValue);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchProdutos, 1000);
    if (this.value && this.value.length) {
      this.items = [...this.items, ...this.value];
    }
  },
};
</script>
